import {createEntityAdapter} from '@reduxjs/toolkit';
import {Connection, ConnectionUser, Workday, WorkspaceReservation} from '../entities';
import {sortConnectionUsers} from './utils';

export const connectionsAdapter = createEntityAdapter<Connection>();

export const connectedUsersAdapter = createEntityAdapter<ConnectionUser>({
  sortComparer: sortConnectionUsers,
});

export const connectionSearchResultsAdapter = createEntityAdapter<ConnectionUser>({
  sortComparer: sortConnectionUsers,
});

export const connectionsWorkspaceReservationsAdapter = createEntityAdapter<WorkspaceReservation>();

export const connectionsWorkdaysAdapter = createEntityAdapter<Workday>();
